import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import AppMember from '@/components/Member/AppMember'
import MemberProfile from '@/components/Member/MemberProfile'
import ClubProfile from '@/components/Club/ClubProfile'
import Grades from '@/components/Member/Grades'
import Stages from '@/components/Member/Stages'
import Formations from '@/components/Member/Formations'
import PalmaresCbt from '@/components/Member/PalmaresCbt'
import PalmaresPoomsae from '@/components/Member/PalmaresPoomsae'
import Arbitrage from '@/components/Member/Arbitrage'
import SyllabusEtDocuments from '@/components/Member/SyllabusEtDocuments'
import Cart from '@/components/Order/Cart'
import Livraison from '@/components/Order/Livraison'
import ChoixModePayement from '@/components/Order/ChoixModePayement'
// import ValidCart from '@/components/ValidCart'
import CongratsOrder from '@/components/Order/CongratsOrder'
import FailingOrder from '@/components/Order/FailingOrder'
import ConfirmOrder from '@/components/Order/ConfirmOrder'
// import PayOrder from '@/components/PayOrder'
import AppClub from '@/components/Club/AppClub'
import store from "../vuex/store";
import ClubListMember from '@/components/Club/ListMembers'
import ClubListRecapitulatifs from '@/components/Club/ClubListRecapitulatifs'
import Inscriptions from '@/components/Club/Inscriptions/Inscriptions'
import { SET_LOADING } from "../vuex/mutations-type";
import { STORAGE_KEY } from "../vuex/local-storage";
import OrderList from "@/components/Order/OrderList";
import NoMemberLinked from "../components/Member/NoMemberLinked.vue";
import ClubLabelisation from "@/components/Club/ClubLabelisation.vue";

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [

    {
      path: '/',
      component: AppMember,
      beforeEnter: guardRouteHaveToLogin,
      meta: { bodyClass: 'hold-transition skin-blue layout-boxed sidebar-mini' },
      children: [
        {
          path: '',
          redirect: 'profile'
        },


        {
          path: 'profile',
          name: 'Profile',
          component: MemberProfile,
          // redirect: 'Boutique'
        },
        {
          path: 'grades',
          name: 'Grades',
          component: Grades
        },
        {
          path: 'stages',
          name: 'Stages',
          component: Stages
        },
        {
          path: 'formations',
          name: 'Formations',
          component: Formations
        },
        {
          path: 'palmares-combat',
          name: 'PalmaresCbt',
          component: PalmaresCbt
        },
        {
          path: 'palmares-poomsae',
          name: 'PalmaresPoomsae',
          component: PalmaresPoomsae
        },
        {
          path: 'arbitrage',
          name: 'Arbitrage',
          component: Arbitrage
        },
        {
          path: 'syllabus-documents',
          name: 'SyllabusEtDocuments',
          component: SyllabusEtDocuments
        },


      ]
    },
    {
      path: 'noMemberLinked',
      name: 'NoMemberLinked',
      component: NoMemberLinked,
      // redirect: 'Boutique'
    },
    {
      path: '/club/:club',
      component: AppClub,
      beforeEnter: guardRouteCanShowClub,
      meta: { bodyClass: 'hold-transition skin-blue layout-boxed sidebar-mini' },
      children: [
        {
          path: '',
          redirect: 'MainFormClub'
        },
        {
          path: 'club',
          name: 'MainFormClub',
          component: ClubProfile,
          // redirect: 'membres'
        },
        {
          path: 'membres',
          name: 'Membres',
          component: ClubListMember,
          // redirect: 'Boutique'
        },
        {
          path: 'recapitulatifs',
          name: 'Recapitulatifs',
          component: ClubListRecapitulatifs,
          // redirect: 'Boutique'
        },
        {
          path: 'inscriptions',
          name: 'Inscriptions',
          component: Inscriptions,
          // redirect: 'Boutique'
        },
        {
          path: 'panier',
          name: 'Panier',
          component: Cart
        },
        {
          path: 'orderList',
          name: 'OrderList',
          component: OrderList
        },
        {
          path: 'livraison',
          name: 'Livraison',
          component: Livraison,
          beforeEnter: function (to, from, next) {
            return guardRouteCartNotEmpty(to, from, next)
          },
        },
        {
          path: 'choixPayement',
          name: 'ChoixPayement',
          component: ChoixModePayement,
          beforeEnter: function (to, from, next) {
            return guardRouteCartNotEmpty(to, from, next) &&
              guardRouteModeLivraisonDefini(to, from, next)
          },
        },
        {
          path: 'confirm',
          name: 'Confirm',
          component: ConfirmOrder,
          beforeEnter: function (to, from, next) {
            return guardRouteCartNotEmpty(to, from, next) &&
              guardRouteModeLivraisonDefini(to, from, next) &&
              guardRouteModePayementDefini(to, from, next)
          },
        },
        // {
        //   path: 'payform',
        //   name: 'PayForm',
        //   component: PayForm,
        //   beforeEnter: function (to, from, next) {
        //     return guardRouteCartNotEmpty(to, from, next) &&
        //       guardRouteModeLivraisonDefini(to, from, next) &&
        //       guardRouteModePayementDefini(to, from, next) &&
        //       guardRouteModePayementVirementElectronique(to, from, next)
        //   },
        // },
        {
          path: 'congratsOrder',
          name: 'CongratsOrder',
          component: CongratsOrder,
          // beforeEnter: function (to, from, next) {
          //   return guardRouteCartNotEmpty(to, from, next) &&
          //     guardRouteModeLivraisonDefini(to, from, next) &&
          //     guardRouteModePayementDefini(to, from, next) &&
          //     guardRouteOrderValidated(to, from, next)
          // },
        },
        {
          path: 'failingOrder',
          name: 'FailingOrder',
          component: FailingOrder,
        },
        {
          path: 'labelisation',
          name: 'ClubLabelisation',
          component: ClubLabelisation
        },
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: { bodyClass: 'login-page-abft' },
    },
    {
      path: '*',
      redirect: 'profile',
      beforeEnter: guardRouteHaveToLogin,
    },
  ]
})

router.beforeEach((to, from, next) => {
  router.app.$options.store.commit('SET_LOADING', true) // shows loading spinner
  setTimeout(next(), 500)
})

router.afterEach(() => {
  router.app.$options.store.commit('SET_LOADING', false) // hides loading spinner
})

function guardRouteCartNotEmpty(to, from, next) {
  const cart = router.app.$options.store.state.stateLocalStorage.syncedData.cart
  if (cart.length <= 0)
    next({
      path: '/panier',
      query: { redirect: to.fullPath }
    })
  else
    next()
}

function guardRouteModePayementDefini(to, from, next) {
  const modePayement = router.app.$options.store.state.stateLocalStorage.syncedData.order.modePayement
  if (modePayement == null)
    next({
      path: '/choixPayement',
      query: { redirect: to.fullPath }
    })
  else
    next()
}
function guardRouteModePayementVirementElectronique(to, from, next) {
  const modePayement = router.app.$options.store.state.stateLocalStorage.syncedData.order.modePayement
  if (modePayement != 'payementElectronique')
    next({
      path: '/choixPayement',
      query: { redirect: to.fullPath }
    })
  else
    next()
}

function guardRouteModeLivraisonDefini(to, from, next) {
  const modeLivraison = router.app.$options.store.state.stateLocalStorage.syncedData.order.modeLivraison
  if (modeLivraison == null)
    next({
      path: '/livraison',
      query: { redirect: to.fullPath }
    })
  else
    next()
}

function guardRouteOrderValidated(to, from, next) {
  const orderValidated = router.app.$options.store.state.stateLocalStorage.syncedData.order.orderValidated
  if (!orderValidated)
    next({
      path: '/Confirm',
      query: { redirect: to.fullPath }
    })
  else
    next()
}

function guardRouteStep4Validated(to, from, next) {
  const orderPayed = router.app.$options.store.state.stateLocalStorage.notSyncedData.order.orderPayed
  if (!orderPayed)
    next({
      path: '/CongratsOrder',
      query: { redirect: to.fullPath }
    })
  else
    next()
}


function guardRouteCanShowClub(to, from, next) {
  var moment = require('moment')

  if (localStorage.getItem(STORAGE_KEY) && !_.isUndefined(localStorage.getItem(STORAGE_KEY)))
    store.commit('SET_DATA_TO_SYNCEDDATA_VUEX', JSON.parse(localStorage.getItem(STORAGE_KEY)))

  const auth = router.app.$options.store.state.stateLocalStorage.syncedData.auth
  const user = router.app.$options.store.state.stateLocalStorage.syncedData.user
  const idClub = router.app.$options.store.state.stateLocalStorage.syncedData.idClubSelected

  if (auth.isLoggedIn &&
    user != null &&
    moment(auth.expires_in).isAfter(moment()) &&
    !_.isUndefined(idClub)) {
    // debugger
    Vue.http.post(process.env.API_URL + "canCheckClubInExtranet", { id_club: idClub }).then((response) => {
      if (response.status != 200)
        next({
          path: '/login',
          query: { redirect: to.fullPath }
        })
      else {
        Vue.http.post(process.env.API_URL + "getInfosClub", { id_club: idClub }).then((response) => {
          store.commit('SET_CLUB', response.body)
          next();
        });
      }
    }, (response) => {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    }
    );
  } else {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  }
}

function guardRouteHaveToLogin(to, from, next) {
  var moment = require('moment')
  // console.log("guardRouteHaveToLogin")
  // console.log(localStorage.getItem("abft_intranet"))

  if (localStorage.getItem(STORAGE_KEY) && !_.isUndefined(localStorage.getItem(STORAGE_KEY)))
    store.commit('SET_DATA_TO_SYNCEDDATA_VUEX', JSON.parse(localStorage.getItem(STORAGE_KEY)))
  // this.setDataToSyncedDataVuex()

  //on synchronise avec le local storage
  //Comme ça, s'il y a déjà eu une premiere connexion, on peut récuprérer le token et l'user
  //Si le localstorage est vide, on renvoie vers le login
  // router.app.$options.store.commit('SYNC_DATA')

  // work-around to get to the Vuex store (as of Vue 2.0)
  const auth = router.app.$options.store.state.stateLocalStorage.syncedData.auth
  const user = router.app.$options.store.state.stateLocalStorage.syncedData.user
  // debugger
  if (!auth.isLoggedIn ||
    moment(auth.expires_in).isBefore(moment()) ||
    user == null) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  } else {
    next()
  }
}

export default router



// WEBPACK FOOTER //
// ./src/router/router.js